import { Select } from 'antd';
import React from 'react';

function SimpleSelectStringTagsA10({ ...props }) {
  return <Select mode="tags" showSearch autoComplete="chrome-off" {...props} />;
}

export default SimpleSelectStringTagsA10;
